import { Component, OnInit, Input } from '@angular/core';
import { faStopwatch20, faAddressCard, faStream, faBell, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from 'src/app/shared/_helpers/authentication.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.css'],
    standalone: false
})
export class UserMenuComponent implements OnInit {

  @Input() orgId: any;
  public icons: { [name: string]: any } = {
    'faStopwatch20': faStopwatch20,
    'faAddressCard': faAddressCard,
    'faStream': faStream,
    'faBell': faBell,
    'faArrowRight': faArrowRight
  };
  public accountType: number;

  constructor(private _authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    const userData = this._authenticationService.currentUserDataValue;
    this.accountType = userData.accountType;
  }

}
